import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, ExternalIcon } from '@skatteetaten/ds-icons';
import { LinkContext } from '../LinkContext/index.esm.js';
import './styles.css';


var styles = {
    "link": "Link-module_link__raCnv",
    "link_white": "Link-module_link_white__5zv7Z",
    "icon": "Link-module_icon__iFD8a",
    "icon_isCustom": "Link-module_icon_isCustom__ZYw7C",
    "icon_isExternal": "Link-module_icon_isExternal__ykmhZ"
};

const Link = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, isExternal, color, svgPath, href, target, download, ariaDescribedby, ariaCurrent, onClick, children }, ref)=>{
    const { t } = useTranslation('ds_buttons', {
        i18n: dsI18n
    });
    const context = useContext(LinkContext);
    const getColor = ()=>{
        if (color) {
            return styles[`link_${color}`];
        } else if (context?.color) {
            return styles[`link_${context?.color}`];
        } else {
            return '';
        }
    };
    const concatenatedClassName = `${styles.link} ${getColor()} ${className}`.trim();
    return /*#__PURE__*/ jsxs("a", {
        ref: ref,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        href: href,
        rel: target === '_blank' ? 'noreferrer' : undefined,
        target: target,
        "aria-current": ariaCurrent,
        "aria-describedby": ariaDescribedby,
        download: download,
        onClick: onClick,
        children: [
            svgPath && /*#__PURE__*/ jsx(Icon, {
                size: 'medium',
                svgPath: svgPath,
                className: `${styles.icon} ${styles.icon_isCustom}`
            }),
            children,
            isExternal && /*#__PURE__*/ jsx(ExternalIcon, {
                size: 'medium',
                className: `${styles.icon} ${styles.icon_isExternal}`,
                ariaLabel: t('shared.ExternalIcon')
            })
        ]
    });
});
Link.displayName = 'Link';

export { Link };
